// Sistema visual único da app — cores, tipografia, espaçamento, raios e sombras.
// Fase 2 da reorganização: usar estes valores em vez de cores/tamanhos soltos
// espalhados pelos componentes, para que a app tenha um aspeto consistente.

// ── Cores, cada uma com uma função fixa (não trocar o significado) ──
export const cor = {
  // Ação principal — botões primários, links, item de menu ativo.
  // Azul Marinho Premium / Navy Coleção (não é o vermelho da marca — esse fica só no logótipo/detalhes).
  acao: "#0B1B3D",
  acaoEscuro: "#061024",
  acaoClaro: "#e9ebf3",
  // Degradê usado nos botões/menu principais, para um acabamento mais elegante e carregado.
  acaoGradiente: "linear-gradient(135deg, #1e3f74 0%, #12294f 30%, #0B1B3D 62%, #030711 100%)",
  acaoGradienteEscuro: "linear-gradient(135deg, #142c54 0%, #0B1B3D 35%, #050b18 70%, #010409 100%)",

  // Vermelho — só para alertas, erros, atrasos e ações destrutivas.
  alerta: "#dc2626",
  alertaEscuro: "#b91c1c",
  alertaClaro: "#fef2f2",

  // Verde — sucesso / concluído.
  sucesso: "#16a34a",
  sucessoEscuro: "#15803d",
  sucessoClaro: "#f0fdf4",

  // Âmbar — atenção / pendente.
  atencao: "#d97706",
  atencaoEscuro: "#b45309",
  atencaoClaro: "#fffbeb",

  // Azul — informação neutra (usado em links/estados informativos, não é ação nem alerta).
  info: "#0284c7",
  infoClaro: "#eff6ff",

  // Vermelho da marca RE/MAX White — só logótipo e pequenos detalhes de identidade.
  marca: "#c8102e",

  // Texto e superfícies neutras.
  texto: "#1a1a2e",
  textoSecundario: "#6b7280",
  textoTerciario: "#9ca3af",
  borda: "#e5e7eb",
  bordaClara: "#ebebeb",
  fundo: "#f4f4f2",
  branco: "#ffffff",
};

// ── Tipografia — 3 níveis de texto + números de indicadores ──
export const tipo = {
  tituloPagina: { fontFamily: "'Playfair Display', serif", fontSize: 26, fontWeight: 700, color: cor.texto },
  tituloSeccao: { fontSize: 18, fontWeight: 600, color: cor.texto },
  texto: { fontSize: 15, color: cor.texto },
  textoSecundario: { fontSize: 13, color: cor.textoSecundario },
  // Números de indicadores/KPIs: grandes, com dígitos de largura fixa (não "dançam" ao mudar de valor).
  indicador: { fontSize: 30, fontWeight: 800, fontVariantNumeric: "tabular-nums", fontFeatureSettings: '"tnum"' },
};

// ── Paleta refinada (WCAG AA) — usada a partir da página Início; as páginas
// que ainda não foram atualizadas continuam a usar `cor` acima até chegarmos
// lá (ver Fase 3+). Nomes e valores exatos definidos com a Sónia.
export const paleta = {
  navy900: "#0B1B3D", navy800: "#13264F", navy700: "#1E3566",
  navy100: "#E7EBF3", navy50: "#F4F6FA",
  cinza900: "#1A1D24", cinza600: "#5B6272", cinza400: "#9AA1AE", cinza200: "#E3E6EC",
  branco: "#FFFFFF",
  perigo: "#B42318", perigoFundo: "#FEF3F2",
  aviso: "#B54708", avisoFundo: "#FFFAEB",
  sucesso: "#067647", sucessoFundo: "#ECFDF3",
};

// ── Espaçamento em múltiplos de 8px ──
export const espaco = (n) => n * 8;

// ── Raios e sombras ──
export const raio = { sm: 8, md: 10, lg: 14, pill: 999 };
export const sombra = {
  sm: "0 1px 3px rgba(0,0,0,0.08)",
  md: "0 4px 14px rgba(0,0,0,0.08)",
  lg: "0 10px 30px rgba(0,0,0,0.12)",
};
